import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* About */}
          <div className="md:col-span-5">
            <h2 className="font-heading text-2xl font-bold mb-4">
              Kakobuy<span className="text-primary-400">Finds</span>
            </h2>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md">
              {t('footer.aboutText')}
            </p>
            <div className="flex gap-3 mt-5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h3 className="font-heading text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/artykul/kakobuy-sheet-kompletny-przewodnik" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  {t('nav.articles')}
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  {t('nav.kakobuySheet')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  {t('nav.buyNow')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h3 className="font-heading text-lg font-semibold mb-4">{t('footer.contactTitle')}</h3>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                <span>{t('footer.email')}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">{t('footer.copyright')}</p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">{t('footer.privacy')}</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}